import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "save",
  "use": "save-usage",
  "viewBox": "0 0 11 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 11 12\" id=\"save\"><path d=\"M10.499 12H.501A.5.5 0 0 1 0 11.499V.501A.5.5 0 0 1 .501 0h7.668c.133 0 .261.053.355.147l2.329 2.329a.503.503 0 0 1 .147.355v8.668a.5.5 0 0 1-.501.501ZM7.863 1.146H1.979v3.675h5.884V1.146Zm-2.553.443h1.269c.093 0 .168.075.168.167V4.2a.168.168 0 0 1-.168.167H5.31a.168.168 0 0 1-.168-.167V1.756c0-.092.075-.167.168-.167Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol